export const SOCIAL_LINKS = [
  // {
  //   link: "https://wellfound.com/u/pablo-mendoza",
  //   icon: "simple-icons:angellist",
  // },
  {
    link: "https://github.com/SuperDev313/",
    icon: "akar-icons:github-fill",
  },
  {
    link: "https://www.linkedin.com/in/hussain",
    icon: "akar-icons:linkedin-fill",
  },
];

export const HERO_TITLES = [
  "Lead FullStack Developer",
  "Frontend Developer",
  "Backend Developer",
  "Blockchain Engineer",
];

export const aboutParagraph = [
  `I am a highly skilled and innovative Full Stack Developer with the extensive experience in designing and developing in web applications using full stack and blockchain technologies. `,
  `First and foremost, client satisfaction is my top priority, and I consider a project successful only when my clients are fully content with the outcome. 
  I place great emphasis on clear and consistent communication, ensuring that my clients and I are always on the same page. I am adaptable and open to changes in project requirements, fostering an environment of collaboration and flexibility.
  Throughout my career, I have focused on writing clear, maintainable code and I am a strong advocate for test-driven development.
  I have collaborated with cross-functional teams, helped resolve blockers and consistently met project deadlines.`,
  `I'd like to contribute my skill and experinces, combined with my ability to the success of your projects or company.`,
  ` Congratulations!`,
];

export const contactEmail = "hussaink001haled@gmail.com";

export const documentTitle = "Hussain";
export const aboutContact = [
  {
    icon: "simple-line-icons:location-pin",
    data: "5 Windsor Ct, Lufkin, TX, 75901",
  },
  {
    icon: "fluent-mdl2:phone",
    data: "+1 281 201 0578",
  },
  {
    icon: "vaadin:envelope-o",
    data: " hussaink001haled@gmail.com",
  },
];
export const contactInfo = {
  description: `I'm actively looking for any new opportunities, my inbox is always open. Whether you have a question or want to hire me or just want to say hello, I'll try my best to get back to you!`,
  contacts: [
    {
      icon: "simple-line-icons:location-pin",
      data: "5 Windsor Ct, Lufkin, TX, 75901",
    },
    {
      icon: "fluent-mdl2:phone",
      data: "+1 281 201 0578",
    },
    {
      icon: "vaadin:envelope-o",
      data: "hussaink001haled@gmail.com",
    },
    {
      icon: "radix-icons:discord-logo",
      data: "_gh0stdev",
    },
    {
      icon: "basil:skype-outline",
      data: "live:.cid.30724e5c2604e743",
    },
    {
      icon: "la:telegram-plane",
      data: "kindman012",
    },
  ],
};
